"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WheelSelectorModal;
var _stylesModule = _interopRequireDefault(require("./styles.module.css"));
var _look = require("../../../assets/wheel-frames/look.svg");
var _sound = require("../../../assets/wheel-frames/sound.svg");
var _ModalState = _interopRequireDefault(require("../../../modal/ModalState"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function WheelSelectorModal() {
  const onWheelSelect = wheelType => {
    _ModalState.default.closeModal(wheelType);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _stylesModule.default.wheelSelectorContainer,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.iconContainer,
      onClick: () => onWheelSelect("look"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_look.ReactComponent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: "OR"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _stylesModule.default.iconContainer,
      onClick: () => onWheelSelect("sound"),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_sound.ReactComponent, {})
    })]
  });
}